import React from 'react';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _map from 'lodash/map';
import _toString from 'lodash/toString';
import _split from 'lodash/split';
import PropTypes from 'prop-types';
// Custom
import { deviceDataShape } from 'constants/PropTypesShapes';
import ConditionInputItem from 'installations/assets/scenarios/ConditionInputItem';
import AppIcon from 'components/icons/AppIcon';

const InputsEventItem = ({ inputsEvent, device, actionDelay }) => {
  const inputEvents = inputsEvent.expression !== '' ? _split(inputsEvent.expression, ';').sort() : null;

  return (
    <div>
      <article className="tl-item">
        <div className="tl-body">
          <div className="tl-entry">
            <div className="tl-caption">
              <span>
                {(actionDelay + inputsEvent.delay) / 10}
                {' '}
                s
              </span>
            </div>
          </div>
        </div>
      </article>
      <article className="tl-item">
        <div className="tl-body pr-3">
          <div className="tl-entry">
            <div className="tl-icon btn-icon">
              <AppIcon defaultColor id="tlEvent" />
            </div>
            <div className="tl-content p-3 w-100">
              {!!inputEvents && _map(inputEvents, (inputEvent, index) => (
                <div key={index} className="information-item-wrapper">
                  <ConditionInputItem
                    key={index}
                    inputCondition={inputEvent}
                    device={device}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </article>
    </div>
  );
};

InputsEventItem.propTypes = {
  inputsEvent: PropTypes.shape({
    delay: PropTypes.number.isRequired,
    expression: PropTypes.string.isRequired,
  }).isRequired,
  device: deviceDataShape.isRequired,
  actionDelay: PropTypes.number.isRequired,
};

const ScenarioLogActionInputsEventsItem = ({ inputsEvents, device, actionDelay }) => (
  <div className="pt-2">
    <div className="row m-0 pb-2">
      <em><LocalizedMessage id="subtitle.inputsEvents" /></em>
    </div>
    <div className="row ml-5">
      <section className="ui-timeline">
        <article className="tl-item">
          <div className="tl-body">
            <div className="tl-entry">
              <div className="tl-icon btn-icon">
                <AppIcon defaultColor id="tlStart" />
              </div>
            </div>
          </div>
        </article>
        {_map(inputsEvents, (inputsEvent) => (
          <InputsEventItem
            key={_toString(inputsEvent.delay)}
            inputsEvent={inputsEvent}
            device={device}
            actionDelay={actionDelay}
          />
        ))}
      </section>
    </div>
  </div>
);

ScenarioLogActionInputsEventsItem.propTypes = {
  inputsEvents: PropTypes.arrayOf(PropTypes.shape({
    delay: PropTypes.number.isRequired,
    expression: PropTypes.string.isRequired,
  })).isRequired,
  device: deviceDataShape.isRequired,
  actionDelay: PropTypes.number.isRequired,
};

module.exports = ScenarioLogActionInputsEventsItem;



// WEBPACK FOOTER //
// ./routes/app/routes/installations/assets/logs/ScenarioLogExecActionInputsEventsItem.js